<script setup lang="ts">
import type { FormItem } from '@/entries/interact-form/types'
import { ANSWER_PREFIX_PATTERN } from '@/entries/interact-form/constants'

const props = defineProps<{
  question: FormItem
}>()

const emit = defineEmits<{
  'update:answer': [value: string]
}>()

/**
 * ラジオボタンの回答を設定
 *
 * ユーザーがラジオボタンを選択したときに呼び出され、
 * 選択された値を親コンポーネントに通知します
 *
 * @param {string} value - 選択された回答の値
 */
function setRadioAnswer(value: string) {
  emit('update:answer', value)
}
</script>

<template>
  <p>単一選択</p>
  <div class="option-group">
    <div v-for="(option, index) in question.data" :key="index" class="option-item">
      <label class="radio-label">
        <input type="radio" :name="`question_${question.id}`" :value="option"
          :checked="question.answer === option" @change="setRadioAnswer(option)" />
        <span class="radio-text">{{ question.is_trigger ? option.replace(ANSWER_PREFIX_PATTERN, '')
          : option
          }}</span>
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.option-group {
  display: flex;
  flex-direction: column;
  border: 1px solid #a5dbdf;
  background-color: #fff;
}

.option-item {
  padding: 12px 16px;
  border-bottom: 1px solid #a5dbdf;
}
.radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  & input {
    width: 16px;
    height: 16px;
    margin: 0;
  }
}

.radio-text {
  margin-left: 10px;
}
</style>
